export const dialogConfig = {
  scrollBy: 100,
};
